import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaInstagram,
  FaPhone,
  FaEnvelope
} from 'react-icons/fa';
import './Footer.css'; 
import logoCaes from '../assets/images/logo.png';

// Importación de logos de organismos
import imgFLH from '../assets/images/Organismos/flh.jpg';
import imgFIH from '../assets/images/Organismos/fih.jpg';
import imgOMS from '../assets/images/Organismos/oms.png';
import imgOPS from '../assets/images/Organismos/ops.jpg';
import imgOISS from '../assets/images/Organismos/oiss.jpg';
import imgISG from '../assets/images/Organismos/isg.png';

const internationalOrganizations = [
  { nombre: 'Federación Latinoamericana de Hospitales (FLH)', logo: imgFLH, url: 'https://www.flh-fhl.org/' },
  { nombre: 'Federación Internacional de Hospitales (FIH)', logo: imgFIH, url: 'https://ihf-fih.org/' },
  { nombre: 'Organización Mundial de la Salud (OMS)', logo: imgOMS, url: 'https://www.who.int/es' },
  { nombre: 'Organización Panamericana de la Salud (OPS)', logo: imgOPS, url: 'https://www.paho.org/es' },
  { nombre: 'Organización Iberoamericana de Seguridad Social (OISS)', logo: imgOISS, url: 'https://oiss.org/' },
  { nombre: 'Instituto de salud publica y gestion sanitaria (ISG)', logo: imgISG, url: 'https://isg.org.ar/' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* --- CONTENIDO PRINCIPAL DEL FOOTER --- */}
        <div className="footer-content">
          <div className="footer-column footer-about">
            <Link to="/" className="footer-logo">
              <img src={logoCaes} alt="Logo CAES" />
            </Link>
            <p className="footer-mission">
              Liderando la evolución del sistema de salud con innovación, excelencia y compromiso.
            </p>
          </div>

          <div className="footer-column footer-links">
            <h4>Navegación</h4>
            <nav>
              <Link to="/institucional#quienes-somos">Quiénes Somos</Link>
              <Link to="/congreso">Congreso</Link>
              <Link to="/noticias">Noticias</Link>
              <Link to="/contacto">Contacto</Link>
            </nav>
          </div>

          <div className="footer-column footer-connect">
            <h4>Contacto y Redes</h4>
            <div className="contact-methods">
              <a href="tel:+541152565093"><FaPhone /> <span>(54-11) 5256-5093</span></a>
              <a href="mailto:caes@caes.org.ar"><FaEnvelope /> <span>caes@caes.org.ar</span></a>
            </div>
            <div className="social-icons">
              <a href="https://facebook.com" aria-label="Facebook" title="Facebook"><FaFacebookF /></a>
              <a href="https://twitter.com" aria-label="Twitter" title="Twitter"><FaTwitter /></a>
              <a href="https://linkedin.com" aria-label="LinkedIn" title="LinkedIn"><FaLinkedinIn /></a>
              <a href="https://instagram.com" aria-label="Instagram" title="Instagram"><FaInstagram /></a>
            </div>
          </div>
        </div>

        {/* --- BARRA INFERIOR DEL FOOTER --- */}
        <div className="footer-bar">
          <p className="copyright">© {currentYear} Cámara Argentina de Empresas de Salud. Todos los derechos reservados.</p>
          <div className="partner-logos">
            <span>Acompañan:</span>
            {internationalOrganizations.map((org) => (
              <a 
                key={org.nombre} 
                href={org.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="partner-logo-item" 
                title={org.nombre}
              >
                <img src={org.logo} alt={org.nombre} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;